// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){

    // ふわっ
    $('.blurTrigger').each(function(){ //fadeUpTriggerというクラス名が
      var elemPos = $(this).offset().top+50;//要素より、300px下の
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight){
      $(this).addClass('blur');// 画面内に入ったらfadeUpというクラス名を追記
      }else{
      $(this).removeClass('blur');// 画面外に出たらfadeUpというクラス名を外す
      }
    });
    $('.blurTrigger2').each(function(){ //fadeUpTriggerというクラス名が
        var elemPos = $(this).offset().top+100;//要素より、300px下の
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight){
        $(this).addClass('blur2');// 画面内に入ったらfadeUpというクラス名を追記
        }else{
        $(this).removeClass('blur2');// 画面外に出たらfadeUpというクラス名を外す
        }
      });
}
  
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
    fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述